import { Tooltip } from "react-bootstrap"
import React from "react"
import states from "src/utilities/States/states"
import AccessLevelTypes from "../Types/AccessLevelTypes"
import ClientPortalEmployeeAccessLevelAreaTypes from "../Types/ClientPortalEmployeeAccessLevelAreaTypes"
import EALAProfitCenterHierarchyTypes from "../Types/EALAProfitCenterHierarchyTypes"
import EALAStateHierarchyTypes from "../Types/EALAStateHierarchyTypes"
import NormalizedReferenceDataTypes from "../Types/NormalizedReferenceDataTypes"
import ProfitCenterTypes from "../Types/ProfitCenterTypes"
import ServiceAreaTypes from "../Types/ServiceAreaTypes"
import StateTypes from "../Types/StateTypes"
import TableIdentifierTypes from "../Types/TableIdentifierTypes"
import addEalaBoiler from "./BoilerPlates/addEalaBoiler"
import hierarchyTreesBoiler from "./BoilerPlates/hierarchyTreesBoiler"
import hashTable from "./HashTable"
import { boolean } from "yup"

const profitCenterTable = new hashTable(500)
const stateTable = new hashTable(50)
const serviceAreaTable = new hashTable(2000)
const ealaTable = new hashTable(500)
const stateIconTable = new hashTable(50)
const date = new Date()

const EALAService = {
    timeZoneOffset: -date.getTimezoneOffset(),
    timeFormat: "MM/DD/YY h:mm a",
    hierarchyTrees: hierarchyTreesBoiler,
    ealas: [],
    reference: {
        accessLevels: [{ accessLevelID: 0, accessDesc: "", }],
        accessLevelsExtended: [{ accessLevelID: 50, accessDesc: "End user", }],
        serviceAreas: [],
        profitCenters: [],
        states: []
    },
    normalizedReferenceData: {
        serviceAreas: [{ id: 0, text: "" }],
        profitCenters: [{ id: 0, text: "" }],
        states: [{ id: 0, text: "" }]
    },
    tableItems: [
        { title: "Area", key: ":)", order: 1, lookupByID: true, checkbox: false, width: "calc(100% - 450px)" },
        { title: "View time", key: "CanViewTime", order: 2, lookupByID: false, checkbox: true, width: "100px" },
        { title: "Edit time", key: "CanEditTime", order: 3, lookupByID: false, checkbox: true, width: "100px" },
        { title: "Supervisor only", key: "LimitToSupervisorEmployees", order: 4, lookupByID: false, checkbox: true, width: "140px" },
        { title: "Dashboard", key: "CanViewDashboard", order: 5, lookupByID: false, checkbox: true, width: "110px" },
        // { title: "Default", key: "IsDefault", order: 6, lookupByID: false, checkbox: true, width: "90px" }
    ].sort(({ order: a }, { order: b }) => a - b),
    helperKeys: [
        ["StateID", "stateTable", "StateName"],
        ["ProfitCenterID", "profitCenterTable", "ProfitCenterLongDesc"],
        ["ServiceAreaID", "serviceAreaTable", "ServiceAreaLongDesc"],
    ],
    buildEalaTable: (ealas: ClientPortalEmployeeAccessLevelAreaTypes[]) => {
        EALAService.purgeHashTable("ealaTable")
        const newEalas = JSON.parse(JSON.stringify(ealas))//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        for (let i = 0; i < newEalas.length; i++) {
            const eala = newEalas[i]
            ealaTable.addItem([`${eala.EmployeeAccessLevelAreaID}`, eala, { drop: false }])
        }
        return Promise.resolve(ealaTable)
        //console.log("EALAService tbl_storage ealaTable", ealaTable.getStorage())
    },
    buildStateTable: (states: StateTypes[]) => {
        EALAService.purgeHashTable("stateTable")
        for (let i = 0; i < states.length; i++) {
            const state = states[i]
            stateTable.addItem([
                `${state.StateID}`,
                state,
                { states: [] },
                { profitCenters: [] },
                { serviceAreas: [] },
                { accessLevelID: 20 },
                { add: false },
                { ...addEalaBoiler },
                { grants: [[20, state.StateID, EALAService.getGrants(20, state.StateID)]] }
            ])
        }
        // console.log("EALAService tbl_storage stateTable", stateTable.getStorage())
    },
    buildProfitCenterTable: (profitCenters: ProfitCenterTypes[]) => {
        EALAService.purgeHashTable("profitCenterTable")
        for (let i = 0; i < profitCenters.length; i++) {
            const profitCenter = profitCenters[i]
            profitCenterTable.addItem([
                `${profitCenter.ProfitCenterID}`
                , profitCenter,
                { states: [] },
                { profitCenters: [] },
                { serviceAreas: [] },
                { accessLevelID: 30 },
                { add: false },
                { ...addEalaBoiler },
                { grants: [[30, profitCenter.ProfitCenterID, EALAService.getGrants(30, profitCenter.ProfitCenterID)]] }
            ])
            let profitCenterState = EALAService.lookupHashTableItem("stateTable", profitCenter.StateID)
            if (profitCenterState) {
                profitCenterState[3].profitCenters.push(profitCenter)
            }
        }
        // console.log("EALAService tbl_storage profitCenterTable", profitCenterTable.getStorage())
    },
    buildServiceAreaTable: (serviceAreas: ServiceAreaTypes[]) => {
        EALAService.purgeHashTable("serviceAreaTable")
        for (let i = 0; i < serviceAreas.length; i++) {
            const serviceArea = serviceAreas[i]
            serviceAreaTable.addItem([
                `${serviceArea.ServiceAreaID}`,
                serviceArea,
                { states: [] },
                { profitCenters: [] },
                { serviceAreas: [] },
                { accessLevelID: 40 },
                { add: false },
                { ...addEalaBoiler },
                { grants: [[40, serviceArea.ServiceAreaID, EALAService.getGrants(40, serviceArea.ServiceAreaID)], [50, serviceArea.ServiceAreaID, EALAService.getGrants(50, serviceArea.ServiceAreaID)]] }
            ])
            let serviceAreaProfitCenter = EALAService.lookupHashTableItem("profitCenterTable", serviceArea.ProfitCenterID)
            if (serviceAreaProfitCenter) {
                serviceAreaProfitCenter[4].serviceAreas.push(serviceArea)
                let serviceAreaState = EALAService.lookupHashTableItem("stateTable", serviceAreaProfitCenter[1].StateID)
                if (serviceAreaState) {
                    serviceAreaState[4].serviceAreas.push(serviceArea)
                }
            }
        }
        // console.log("EALAService tbl_storage serviceAreaTable", serviceAreaTable.getStorage())
    },
    buildStateIconTable: () => {
        EALAService.purgeHashTable("stateIconTable")
        for (let i = 0; i < states.length; i++) {
            const state = states[i]
            stateIconTable.addItem([
                `${state.StateID}`,
                state
            ])
        }
        //console.log("EALAService tbl_storage stateIconTable", stateIconTable.getStorage())
    },
    getGrants: (AccessLevelID: number, itemID: number) => {
        const ealas = EALAService.ealas
        const key = AccessLevelID === 20 ? "StateID" : AccessLevelID === 30 ? "ProfitCenterID" : "ServiceAreaID"
        for (let i = 0; i < ealas.length; i++) {
            const eala = ealas[i]
            //@ts-ignore
            if (eala.AccessLevelID === AccessLevelID && eala[key] === itemID) {
                return true
            }
        }
        return false
    },
    getTableByIdentifier: (tableIdentifier: TableIdentifierTypes) => {
        const table =
            tableIdentifier === "profitCenterTable" ? profitCenterTable :
                tableIdentifier === "stateTable" ? stateTable :
                    tableIdentifier === "serviceAreaTable" ? serviceAreaTable :
                        tableIdentifier === "stateIconTable" ? stateIconTable :
                            ealaTable
        return table
    },
    getTableIdentifierByAccessLevelID: (id: number) => {
        const tableIdentifier =
            id === 20 ? "stateTable" :
                id === 30 ? "profitCenterTable" :
                    id === 40 ? "serviceAreaTable" :
                        id === 50 ? "serviceAreaTable" :
                            null
        return tableIdentifier
    },
    purgeHashTable: (tableIdentifier: TableIdentifierTypes) => {
        EALAService.getTableByIdentifier(tableIdentifier).purgeTable(false)
    },
    lookupHashTableItem: (tableIdentifier: TableIdentifierTypes, id: number, debug?: boolean) => {
        const item = EALAService.getTableByIdentifier(tableIdentifier).lookupItem([`${id}`])
        if (debug) {
            console.log("lookupHashTableItem debug", tableIdentifier, id, item)
        }
        return item
    },
    updateHashTableItem: (tableIdentifier: TableIdentifierTypes, bucketItem: any) => {
        EALAService.getTableByIdentifier(tableIdentifier).updateItem(bucketItem)
    },
    addHashTableItem: (tableIdentifier: TableIdentifierTypes, bucketItem: any) => {
        EALAService.getTableByIdentifier(tableIdentifier).addItem(bucketItem)
    },
    deleteHashTableItem: (tableIdentifier: TableIdentifierTypes, bucketItem: any) => {
        EALAService.getTableByIdentifier(tableIdentifier).deleteItem(bucketItem[0])
    },
    getHashTableStorage: (tableIdentifier: TableIdentifierTypes) => {
        return EALAService.getTableByIdentifier(tableIdentifier).getStorage()
    },
    setUpTables: (states: StateTypes[], profitCenters: ProfitCenterTypes[], serviceAreas: ServiceAreaTypes[]) => {
        EALAService.buildStateTable(states)
        EALAService.buildProfitCenterTable(profitCenters)
        EALAService.buildServiceAreaTable(serviceAreas)
        EALAService.buildStateIconTable()
        EALAService.buildHierarchyTrees(states, profitCenters)
    },
    getServiceAreasByProfitCenterID: (id: number) => {
        const bucketItem = EALAService.lookupHashTableItem("profitCenterTable", id)
        if (bucketItem) {
            return bucketItem[4].serviceAreas
        }
        return { serviceAreas: [] }

    },
    normalizeReferenceData: (idKey: string, textKey: string, data: any[]) => {
        let normalized: NormalizedReferenceDataTypes = []
        for (let i = 0; i < data.length; i++) {
            let normalizedItem = { id: 0, text: "" }
            normalizedItem.id = data[i][idKey]
            normalizedItem.text = data[i][textKey]
            normalized.push(normalizedItem)
        }
        return normalized
    },
    getNormalizedReferenceDataByAccessLevelID: (accessLevelID: number) => {
        const { states, profitCenters, serviceAreas } = EALAService.normalizedReferenceData
        return (
            accessLevelID === 50 ? serviceAreas
                : accessLevelID === 40 ? serviceAreas
                    : accessLevelID === 30 ? profitCenters
                        : accessLevelID === 20 ? states
                            : []
        )
    },
    filterEALASByAccessLevelID: (ealas: ClientPortalEmployeeAccessLevelAreaTypes[], id: number) => {
        let filteredEALAS: ClientPortalEmployeeAccessLevelAreaTypes[] = []
        if (id > 0) {
            for (let i = 0; i < ealas.length; i++) {
                const eala = ealas[i]
                if (eala.AccessLevelID === id) {
                    filteredEALAS.push(eala)
                }
            }
            return filteredEALAS
        } else if (id < 0) {
            return ealas
        }
        return EALAService.getDefaultEALAS(ealas)
    },
    getDefaultEALAS: (ealas: ClientPortalEmployeeAccessLevelAreaTypes[]) => {
        let defaultEALAS: ClientPortalEmployeeAccessLevelAreaTypes[] = []
        for (let i = 0; i < ealas.length; i++) {
            const eala = ealas[i]
            if (eala.IsDefault > 0) {
                defaultEALAS.push(eala)
            }
        }
        return defaultEALAS
    },
    getDefaultEALA: (ealas: ClientPortalEmployeeAccessLevelAreaTypes[]) => {
        for (let i = 0; i < ealas.length; i++) {
            const eala = ealas[i]
            if (eala.IsDefault > 0) {
                return eala
            }
        }
        return addEalaBoiler
    },
    sortByDefault: (ealas: ClientPortalEmployeeAccessLevelAreaTypes[]) => {
        return ealas.sort(({ IsDefault: a }, { IsDefault: b }) => b - a)
    },
    getLocationDescriptions: (eala: ClientPortalEmployeeAccessLevelAreaTypes) => {
        const { helperKeys, lookupHashTableItem } = EALAService
        let titles = { StateName: null, ProfitCenterLongDesc: null, ServiceAreaLongDesc: null }
        for (let i = 0; i < helperKeys.length; i++) {
            const key = helperKeys[i]
            const EALAKey = key[0]
            const tableIdentifier = key[1]
            const bucketItemDescrptionKey = key[2]
            //@ts-ignore
            const bucketItem = lookupHashTableItem(tableIdentifier, eala[EALAKey])
            if (bucketItem) {
                //@ts-ignore
                titles[bucketItemDescrptionKey] = bucketItem[1][bucketItemDescrptionKey]
            }
        }
        return titles
    },
    getSelectedAccessLevelByID: (id: number, accessLevels: AccessLevelTypes[]) => {
        for (let i = 0; i < accessLevels.length; i++) {
            const accessLevel = accessLevels[i]
            if (accessLevel.accessLevelID === id) {
                return accessLevel
            }
        }
        return { accessLevelID: 50, accessDesc: "End user", }
    },
    getAccessLevelByAccessLevelID: (id: number) => {
        const accessLevels = EALAService.reference.accessLevels
        for (let i = 0; i < accessLevels.length; i++) {
            const accessLevel = accessLevels[i]
            if (accessLevel.accessLevelID === id) {
                return accessLevel
            }
        }
        return { accessLevelID: -1, accessDesc: "NA" }
    },
    checkForAddOrDropOrSame: (eala: ClientPortalEmployeeAccessLevelAreaTypes, key: string) => {
        const { lookupHashTableItem } = EALAService
        const bucketItem = lookupHashTableItem("ealaTable", eala.EmployeeAccessLevelAreaID)
        if (bucketItem) {
            const a = bucketItem[1][key]
            //@ts-ignore
            const b = eala[key]
            if ((a === true || a === 1) && (b === false || b === 0)) {
                return "Drop"
            } else if ((a === false || a === 0) && (b === true || b === 1)) {
                return "Add"
            }
        }
        return "Same"
    },
    checkForDropEala: (eala: ClientPortalEmployeeAccessLevelAreaTypes) => {
        const { lookupHashTableItem } = EALAService
        const bucketItem = lookupHashTableItem("ealaTable", eala.EmployeeAccessLevelAreaID)
        if (bucketItem) {
            return bucketItem[2].drop
        }
        return false
    },
    getAvailableAreas: (AccessLevelID: number) => {
        const areas = EALAService.getNormalizedReferenceDataByAccessLevelID(AccessLevelID)
        const { lookupHashTableItem, getTableIdentifierByAccessLevelID } = EALAService
        let filtered: NormalizedReferenceDataTypes = []
        for (let i = 0; i < areas.length; i++) {
            const area = areas[i]
            const bucketItem = lookupHashTableItem(getTableIdentifierByAccessLevelID(AccessLevelID), area.id)
            const grants = bucketItem[8].grants
            for (let j = 0; j < grants.length; j++) {
                const grant = grants[j]
                if (grant[0] === AccessLevelID && !grant[2]) {
                    filtered.push(area)
                }
            }
        }
        return filtered
    },
    getAvailableAreasScopedByProfitCenterID: (AccessLevelID: number, ProfitCenterID: number, override?: boolean) => {
        const areas = EALAService.getNormalizedReferenceDataByAccessLevelID(AccessLevelID)
        const { lookupHashTableItem } = EALAService
        let filtered: NormalizedReferenceDataTypes = []
        for (let i = 0; i < areas.length; i++) {
            const area = areas[i]
            const bucketItem = lookupHashTableItem("serviceAreaTable", area.id)
            if (bucketItem) {
                const pcID = bucketItem[1].ProfitCenterID
                const grants = bucketItem[8].grants
                for (let j = 0; j < grants.length; j++) {
                    const grant = grants[j]
                    if ((grant[0] === AccessLevelID && !grant[2]) && (pcID === ProfitCenterID) && (!override)) {
                        filtered.push(area)
                    } else if (grant[0] === AccessLevelID && override) {
                        filtered.push(area)
                    }
                }
            }
        }
        return filtered
    },
    buildHierarchyTrees: (states: StateTypes[], profitCenters: ProfitCenterTypes[]) => {
        const { lookupHashTableItem } = EALAService
        let stateHierarchyTree: EALAStateHierarchyTypes = { states: [] }
        let profitCenterHierarchyTree: EALAProfitCenterHierarchyTypes = { profitCenters: [] }

        for (let i = 0; i < states.length; i++) {
            const state = states[i]
            stateHierarchyTree.states.push({ state: state, profitCenters: [] })
            const stateBucket = lookupHashTableItem("stateTable", state.StateID)
            const profitCenters = stateBucket[3].profitCenters
            if (profitCenters) {
                for (let j = 0; j < profitCenters.length; j++) {
                    const profitCenter = profitCenters[j]
                    stateHierarchyTree.states[i].profitCenters.push({ profitCenter: profitCenter, serviceAreas: [] })
                    const profitCenterBucket = lookupHashTableItem("profitCenterTable", profitCenter.ProfitCenterID)
                    if (profitCenterBucket) {
                        const serviceAreas = profitCenterBucket[4].serviceAreas
                        for (let k = 0; k < serviceAreas.length; k++) {
                            const serviceArea = serviceAreas[k]
                            stateHierarchyTree.states[i].profitCenters[j].serviceAreas.push(serviceArea)
                        }
                    }
                }
            }
        }

        for (let i = 0; i < profitCenters.length; i++) {
            const profitCenter = profitCenters[i]
            const profitCenterBucket = lookupHashTableItem("profitCenterTable", profitCenter.ProfitCenterID)
            if (profitCenterBucket) {
                profitCenterHierarchyTree.profitCenters.push({ profitCenter: profitCenter, serviceAreas: [] })
                const serviceAreas = profitCenterBucket[4].serviceAreas
                for (let j = 0; j < serviceAreas.length; j++) {
                    const serviceArea = serviceAreas[j]
                    profitCenterHierarchyTree.profitCenters[i].serviceAreas.push(serviceArea)
                }
            }
        }

        const trees = { stateHierarchyTree: stateHierarchyTree, profitCenterHierarchyTree: profitCenterHierarchyTree }
        //console.log("buildHierarchyTrees", trees)
        //@ts-ignore
        EALAService.hierarchyTrees = trees
    },
    getStateFromStateHierarchyTree: (StateID: number) => {
        const states = EALAService.hierarchyTrees.stateHierarchyTree.states
        for (let i = 0; i < states.length; i++) {
            const state = states[i]
            if (state.state.StateID === StateID) {
                return state
            }
        }
        return states[0]
    },
    getProfitCenterFromStateHierarchyTree: (ProfitCenterID: number) => {
        const profitCenters = EALAService.hierarchyTrees.profitCenterHierarchyTree.profitCenters
        for (let i = 0; i < profitCenters.length; i++) {
            const profitCenter = profitCenters[i]
            if (profitCenter.profitCenter.ProfitCenterID === ProfitCenterID) {
                return profitCenter
            }
        }
        return profitCenters[0]
    },
    editEALASSaveSetup: (ealas: ClientPortalEmployeeAccessLevelAreaTypes[], overrideDirtyCheck?: boolean) => {
        const { checkIfEditIsDirty } = EALAService
        let ealasToSave: ClientPortalEmployeeAccessLevelAreaTypes[] = []
        for (let i = 0; i < ealas.length; i++) {
            let ealaToSave = ealas[i]
            if (!overrideDirtyCheck) {//!!!!!!!fix this!!!
                if (checkIfEditIsDirty([ealaToSave])) {
                    ealaToSave.IsDefault = ealaToSave.IsDefault ? 1 : 0
                    ealasToSave.push(ealaToSave)
                }
            } else {
                ealaToSave.IsDefault = ealaToSave.IsDefault ? 1 : 0
                ealasToSave.push(ealaToSave)
            }
        }
        return ealasToSave
    },
    addEALASSaveSetup: (EmployeeID: number, AccessLevelID: number) => {
        let ealasToAdd: ClientPortalEmployeeAccessLevelAreaTypes[] = []
        const tableIdentifiers: TableIdentifierTypes[] = ["stateTable", "profitCenterTable", "serviceAreaTable"]
        for (let i = 0; i < tableIdentifiers.length; i++) {
            const tableIdentifier = tableIdentifiers[i]
            const table = EALAService.getHashTableStorage(tableIdentifier)
            for (let j = 0; j < table.length; j++) {
                const bucket = table[j]
                if (bucket) {
                    for (let k = 0; k < bucket.length; k++) {
                        if (bucket[k][6].add) {
                            let ealaToAdd: ClientPortalEmployeeAccessLevelAreaTypes = bucket[k][7]
                            ealaToAdd.AccessLevelID = AccessLevelID
                            ealaToAdd.EmployeeID = EmployeeID
                            ealaToAdd.IsDefault = ealaToAdd.IsDefault ? 1 : 0
                            ealaToAdd.StateID = bucket[k][1].hasOwnProperty("StateID") ? bucket[k][1].StateID : null
                            ealaToAdd.ProfitCenterID = bucket[k][1].hasOwnProperty("ProfitCenterID") ? bucket[k][1].ProfitCenterID : null
                            ealaToAdd.ServiceAreaID = bucket[k][1].hasOwnProperty("ServiceAreaID") ? bucket[k][1].ServiceAreaID : null
                            ealasToAdd.push(bucket[k][7])
                            bucket[k][6].add = false
                            bucket[k][7] = addEalaBoiler
                            EALAService.updateHashTableItem(tableIdentifier, bucket[k])
                        }
                    }
                }
            }
        }
        return ealasToAdd
    },
    checkIfEditIsDirty: (ealas: ClientPortalEmployeeAccessLevelAreaTypes[]) => {
        const { lookupHashTableItem } = EALAService
        for (let i = 0; i < ealas.length; i++) {
            const eala = ealas[i]
            const bucketItem = lookupHashTableItem("ealaTable", eala.EmployeeAccessLevelAreaID)
            if (bucketItem) {
                const a = (eala.CanViewTime === bucketItem[1].CanViewTime)
                const b = (eala.CanEditTime === bucketItem[1].CanEditTime)
                const c = (eala.LimitToSupervisorEmployees === bucketItem[1].LimitToSupervisorEmployees)
                const d = (eala.CanViewDashboard === bucketItem[1].CanViewDashboard)

                if (!a || !b || !c || !d || bucketItem[2].drop) {
                    return true
                }
            }
        }
        return false
    },
    checkIfAddIsDirty: (AccessLevelID: number, areasCopy: NormalizedReferenceDataTypes) => {
        const { lookupHashTableItem, getTableIdentifierByAccessLevelID } = EALAService
        for (let i = 0; i < areasCopy.length; i++) {
            const area = areasCopy[i]
            const bucketItem = lookupHashTableItem(getTableIdentifierByAccessLevelID(AccessLevelID), area.id)
            if (bucketItem && bucketItem[6].add) {
                return true
            }
        }
        return
    },
    purgeAdds: (AccessLevelID: number, areasCopy: NormalizedReferenceDataTypes) => {
        const { lookupHashTableItem, getTableIdentifierByAccessLevelID } = EALAService
        for (let i = 0; i < areasCopy.length; i++) {
            const area = areasCopy[i]
            const bucketItem = lookupHashTableItem(getTableIdentifierByAccessLevelID(AccessLevelID), area.id)
            if (bucketItem && bucketItem[6].add) {
                bucketItem[6].add = false
            }
        }
    },
    getPromotionSuggestion: (AccessLevelID: number) => {
        const accessLevels = EALAService.reference.accessLevels.sort(({ accessLevelID: b }, { accessLevelID: a }) => a - b)
        for (let i = 0; i < accessLevels.length; i++) {
            const level = accessLevels[i]
            if (level.accessLevelID < AccessLevelID) {
                return level.accessDesc
            }
        }
        return ""
    },
    EALAServiceTooltip: (text: string) => (
        <Tooltip id={`eala-service-tooltip`}>
            {text}
        </Tooltip>
    )
}

export default EALAService